import { forwardRef, type Ref, type ReactNode } from 'react';
import type { BaseProps } from '../../theme/index.js';
import { useBaseAttrs, splitBaseProps } from '../../core/_internal/factory.js';
import './EmptyState.css';

export interface EmptyStateProps extends BaseProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

/** Empty-state placeholder: icon + title + description + action. */
export const EmptyState = forwardRef(function EmptyState(
  { icon, title, description, action, ...rest }: EmptyStateProps,
  ref: Ref<HTMLDivElement>
): ReactNode {
  const base = useBaseAttrs('rr-empty-state', rest);
  const { dom } = splitBaseProps(rest);
  return (
    <div {...dom} ref={ref} {...base.attrs} className={base.className} style={base.style}>
      {icon ? <div className="rr-empty-state__icon">{icon}</div> : null}
      {title ? <div className="rr-empty-state__title">{title}</div> : null}
      {description ? <div className="rr-empty-state__description">{description}</div> : null}
      {action ? <div className="rr-empty-state__action">{action}</div> : null}
    </div>
  );
});
